import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';

interface LabCatalog {
  panels: { id: string; label: string; tests: string[] }[];
  tests: string[];
}

/**
 * Fetches the lab test catalog + suggested panels for the order composer
 * (GET /private/careos/labs/catalog). Static reference data — production
 * replaces it with the Healthie API.
 */
export const useLabCatalog = () => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<LabCatalog, Error>({
    queryKey: ['careos-lab-catalog', userToken],
    queryFn: () => api({ route: '/private/careos/labs/catalog', token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { panels: data?.panels ?? [], tests: data?.tests ?? [], isLoading, isError };
};
